import { render, staticRenderFns } from "./physicsbodyEditing.vue?vue&type=template&id=ad2e3a72&"
import script from "./physicsbodyEditing.vue?vue&type=script&lang=js&"
export * from "./physicsbodyEditing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports